import slick from '../modules/slick';

export default () => {
    let servicesSlider = $('.services__slider');
    servicesSlider.on('init', function () {
        servicesSlider.animate({opacity:1});
    });
    slick(servicesSlider, {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        fade: false,
        responsive: [
            {
                breakpoint: 1439,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    verticalSwiping: true,
                    vertical: true,
                }
            }
        ],
        // appendArrows: '.slide-count'
        // prevArrow: '.slide-count__button_prev',
        nextArrow: '.services__next'
    });
};


// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/components/services.js